import { Work } from "@/sections/Work";
import { Reveal } from "@/components/Reveal";

export default function WorkPage() {
  return (
    <main data-testid="work-page" className="pt-16 lg:pt-20">
      <Work />
      <section data-testid="work-statement" className="border-t border-white/5 py-28 lg:py-36 px-5 sm:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <Reveal>
            <p className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-neutral-50 leading-[1.15]">
              Different brands. Different problems.{" "}
              <span className="underline decoration-neutral-600 underline-offset-8">Same care.</span>
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
